import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Collapses its children on small screens; always expanded from md upwards.
export const MobileCollapse = ({ id, label = "Mehr anzeigen", className = "", children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div data-testid={`${id}-body`} className={`${open ? "" : "hidden"} md:block ${className}`}>{children}</div>
      <button type="button" data-testid={`${id}-toggle`} aria-expanded={open} onClick={() => setOpen((v) => !v)}
        className={`md:hidden ${open ? "mt-5" : "mt-1"} inline-flex items-center gap-2 min-h-[44px] text-sm font-head font-semibold text-[#8A0093]`}>
        {open ? "Weniger anzeigen" : label}<ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
    </>
  );
};
